export const DEFAULT_MEMBER_PROGRAM_DISCOUNT = 20;

export const isIncludedWithMembership = (program) => {
  if (!program || program.isSubscription) return false;
  if (program.includedWithMembership === true) return true;
  const amount = Number(program.amount);
  return !Number.isFinite(amount) || amount === 0;
};

export const getMemberDiscountPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return DEFAULT_MEMBER_PROGRAM_DISCOUNT;
  if (n > 100) return 100;
  return n;
};

export const getNonMemberPrice = (program) => {
  if (program?.nonMemberAmount != null) return Number(program.nonMemberAmount);
  return Number(program?.amount) || 0;
};

export const getMemberPrice = (program, discountPercent) => {
  if (isIncludedWithMembership(program)) return 0;
  if (program?.memberAmount != null) return Number(program.memberAmount);
  const amount = getNonMemberPrice(program);
  const pct = getMemberDiscountPercent(discountPercent);
  return Math.round(amount * (1 - pct / 100) * 100) / 100;
};

export const formatProgramPrice = (amount, currency = "usd") => {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  const code = String(currency || "usd").toLowerCase();
  const symbol = code === "usd" ? "$" : `${code.toUpperCase()} `;
  const formatted = Number.isInteger(n) ? String(n) : n.toFixed(2);
  return `${symbol}${formatted}`;
};

export const stripHtml = (value) =>
  String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const programTopic = (program) => {
  const names = program?.wordpressCategoryName;
  const raw = Array.isArray(names)
    ? String(names[0] || "")
    : typeof names === "string"
      ? names.split(",")[0]
      : "";
  const topic = raw.trim();
  if (!topic || /^default category$/i.test(topic)) return "";
  return topic;
};

export const programTeacher = (program) => {
  const teacher =
    program?.teacher ||
    program?.teacherName ||
    program?.instructor ||
    "";
  return String(teacher).trim();
};
